module.exports = vendors_ru_8feb652e2992350e0d76;